module.exports = __webpack_public_path__ + "img/51.3990dc83.jpg";